import 'rxjs/add/operator/map';
import {
    NewBookingInterface,
    PostLoginObject,
    PostLoginResponse,
    PostRegisterObject,
    PostRegisterResponse,
    PostSearchSailingsObject
} from '../interfaces/api';
import { Booking } from '../entities/booking';
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { Port } from '../entities/port';
import { RequestOptionsArgs } from '@angular/http/src/interfaces';
import { Route } from '../entities/route';
import { Sailing } from '../entities/sailing';
import { Shared } from './shared';
import { ShippingLine } from '../entities/shipping-line';
import { User } from '../entities/user';
import { Vehicle } from '../entities/vehicle';
import { VehicleType } from '../entities/vehicle-type';

@Injectable()
export class Api {

    private apiToken: string;

    /**
     * @type {string}
     */
    // endpoint: string = 'http://10.0.1.201:8080/api/v1/';
    // endpoint: string = 'http://10.0.1.113:8080/api/v1/';
    // endpoint: string = 'http://localhost:8080/api/v1/';
    // endpoint: string = 'http://lrtr2ri9vppqada4f-mock.stoplight-proxy.io/api/v1/';
    endpoint: string = 'https://diarytmf.herokuapp.com/api/v1/';

    constructor(
        private http: Http,
        private shared: Shared,
    ) {
    }

    async get(method: string, options?: RequestOptionsArgs): Promise<any> {
        if (method === undefined) throw new Error('No API method defined');
        let url = this.endpoint + method;
        return this.http.get(url, options).toPromise();
    }

    async post(method: string, body: any): Promise<any> {
        if (typeof method === 'undefined') throw new Error('No API method defined');
        let options: RequestOptionsArgs = Api.options();
        let json: string = JSON.stringify(body);
        let url = this.endpoint + method;
        return this.http.post(url, json, options).toPromise();
    }

    async getSecure(method: string): Promise<any> {
        if (method === undefined) throw new Error('No API method defined');
        await this.setApiToken();
        let options: RequestOptionsArgs = Api.secureOptions(this.apiToken);
        let url = this.endpoint + method;
        return this.http.get(url, options).toPromise();
    }

    async postSecure(method: string, body: any): Promise<any> {
        if (method === undefined) throw new Error('No API method defined');
        await this.setApiToken();
        let options: RequestOptionsArgs = Api.secureOptions(this.apiToken);
        let json: string = JSON.stringify(body);
        let url = this.endpoint + method;
        return this.http.post(url, json, options).toPromise();
    }

    async getAllRoutesForPort(port: Port): Promise<Route[]> {
        let method: string = 'ports/' + port.abbr.toLowerCase() + '/routes';
        try {
            let response = await this.get(method);
            let json = response.json();
            if (json === undefined || json.routes === undefined) return null;
            return Route.createFromObjects(json.routes);
        } catch (e) {
            return [];
        }
    }

    async postRegister(body: PostRegisterObject): Promise<PostRegisterResponse> {
        try {
            let response: any = await this.post('register', body);
            return response.json();
        } catch (e) {
            return {success: false};
        }
    }

    async postLogin(body: PostLoginObject): Promise<PostLoginResponse> {
        try {
            let response: any = await this.post('login', body);
            return response.json();
        } catch (e) {
            return {success: false};
        }
    }

    async postSailings(body: PostSearchSailingsObject): Promise<Sailing[]> {
        try {
            let response = await this.post('sailings', body);
            let json = response.json();
            if (json === undefined || json.sailings === undefined) return null;
            let arrivalPort = json.arrival_port;
            return Sailing.createFromObjects(json.sailings, arrivalPort);
        } catch (e) {
            return [];
        }
    }

    async getMyDetails(): Promise<User> {
        try {
            let response: any = await this.getSecure('me/details');
            let json = response.json();
            if (json === undefined || json.user === undefined) return;
            return User.createFromObject(json.user);
        } catch (e) {
        }
    }

    async getMyBooking(booking: Booking): Promise<Booking> {
        try {
            let response: any = await this.getSecure('me/bookings/' + booking.id);
            let json = response.json();
            if (json === undefined || json.booking === undefined) return null;
            return Booking.createFromObject(json.booking);
        } catch (e) {
        }
    }

    async getMyBookings(): Promise<Booking[]> {
        try {
            let response: any = await this.getSecure('me/bookings');
            let json = response.json();
            if (json === undefined || json.bookings === undefined) return null;
            return Booking.createFromObjects(json.bookings);
        } catch (e) {
            return [];
        }
    }

    async getSailingsForRoute(route: Route, date: string): Promise<Sailing[]> {
        try {
            let response: any = await this.getSecure('routes/' + route.id + '/sailings/' + date);
            let json = response.json();
            if (json === undefined || json.sailings === undefined) return null;
            let arrivalPort = json.arrival_port;
            return Sailing.createFromObjects(json.sailings, arrivalPort);
        } catch (e) {
            return [];
        }
    }

    async getAllPorts(): Promise<Port[]> {
        try {
            let response: any = await this.getSecure('ports');
            let json = response.json();
            if (json === undefined || json.ports === undefined) return null;
            return Port.createFromObjects(json.ports);
        } catch (e) {
            return [];
        }
    }

    async getMyVehicles(): Promise<Vehicle[]> {
        try {
            let response: any = await this.getSecure('me/vehicles');
            let json = response.json();
            if (json === undefined || json.vehicles === undefined) return null;
            return Vehicle.createFromObjects(json.vehicles);
        } catch (e) {
            return [];
        }
    }

    async getVehicleTypes(): Promise<VehicleType[]> {
        try {
            let response: any = await this.getSecure('vehicles/types');
            let json = response.json();
            if (json === undefined || json.types === undefined) return null;
            return VehicleType.createFromObjects(json.types);
        } catch (e) {
            return [];
        }
    }

    async getShippingLines(): Promise<ShippingLine[]> {
        try {
            let response: any = await this.getSecure('shippinglines');
            let json = response.json();
            if (json === undefined || json.shippinglines === undefined) return null;
            return ShippingLine.createFromObjects(json.shippinglines);
        } catch (e) {
            return [];
        }
    }

    async postNewBookings(body: NewBookingInterface): Promise<boolean> {
        try {
            let response: any = await this.postSecure('me/bookings/new', body);
            let json = response.json();
            if (json === undefined || json.success === undefined) return false;
            return json.success;
        } catch (e) {
            return false;
        }
    }

    private async setApiToken() {
        this.apiToken = this.shared.get('apiToken');
        if (this.apiToken === undefined) {
            await this.shared.getConfigAndSetShared('apiToken');
            this.apiToken = this.shared.get('apiToken');
        }
    }

    static getHeaders(additional?: { [name: string]: any }): Headers {
        let headers = new Headers();

        if (additional) {
            for (let name in additional) {
                let value = additional[name];
                headers.append(name, value);
            }
        }

        return headers;
    }

    static options(): RequestOptionsArgs {
        return {
            headers: Api.getHeaders({
                'Content-Type': 'application/json',
            })
        };
    }

    static secureOptions(apiToken: string): RequestOptionsArgs {
        return {
            headers: Api.getHeaders({
                'Content-Type': 'application/json',
                'Authorization': apiToken,
            })
        };
    }
}



// WEBPACK FOOTER //
// ./src/providers/api.ts